import { Link } from "react-router-dom";
import type { Article } from "@/types/film";

interface ReviewHighlightsProps {
  articles: Article[];
  onOpen?: (article: Article) => void;
}

export default function ReviewHighlights({ articles, onOpen }: ReviewHighlightsProps) {
  return (
    <section className="w-full bg-background-100 px-4 py-12 md:px-10 md:py-16">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <span className="font-label text-[11px] uppercase tracking-[0.3em] text-accent-600">Analysis</span>
          <h2 className="mt-2 font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">
            影评与分析精选
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            从叙事结构到伦理立场，我们把作品拆开来看。
          </p>
        </div>
        <Link
          to="/reviews"
          className="flex items-center gap-1.5 whitespace-nowrap text-sm text-primary-600 transition-colors hover:text-accent-600 cursor-pointer"
        >
          全部专题
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6">
        {articles.map((article) => (
          <article
            key={article.id}
            className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
          >
            <span className="w-fit rounded-sm bg-accent-100 px-2 py-0.5 text-[11px] text-accent-800">
              {article.tag}
            </span>
            <h3 className="mt-3 font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
              {article.title}
            </h3>
            <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600 clamp-3">
              {article.excerpt}
            </p>
            <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
              <div className="text-[11px] text-foreground-500">
                {article.author} · {article.date}
              </div>
              <button
                type="button"
                onClick={() => onOpen?.(article)}
                className="flex items-center gap-1 whitespace-nowrap text-xs text-primary-600 transition-colors hover:text-accent-600 cursor-pointer"
              >
                阅读全文
                <i className="ri-arrow-right-line" />
              </button>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}